import React from "react";
import { object, array, string, bool } from "prop-types";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import LinkTag from "../link-tag";

import { getHeadline } from "../../utils/utils";

import "./customStoryCard4.m.css";

const CustomStoryCard4 = ({ story, aspectRatio, imageType, isExternalStory }) => {
  const headline = getHeadline(story);

  return (
    <div styleName="wrapper" className="custom-story-card-4">
      <LinkTag href={story.url} styleName="title-wrapper" isExternalStory={isExternalStory}>
        <Headline text={headline} headerType={4} headerLevel={2} title={headline} story={story} />
      </LinkTag>
      <LinkTag href={story.url} isExternalStory={isExternalStory}>
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={[140]}
          eager={true}
          showStoryTypeIcon
        />
      </LinkTag>
    </div>
  );
};

CustomStoryCard4.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
};

CustomStoryCard4.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  isExternalStory: bool,
};

export default CustomStoryCard4;
